import { LocaleTerms } from '../en/terms'

const terms: LocaleTerms = {}

export default terms
